// @ts-nocheck
import * as Types from '../../types/types';

import * as Operations from '../../queries';
import * as Apollo from '@apollo/client/react';
const defaultOptions = {} as const;
export type GetAiProvidersQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetAiProvidersQuery = {
  __typename?: 'Query';
  ai?: {
    __typename?: 'AI';
    url: string;
    token: string;
    providers: Array<{
      __typename?: 'AIProvider';
      name: string;
      workflows: Array<{
        __typename?: 'AIProviderWorkflow';
        id: string;
        workflow: string;
        label: string;
      } | null>;
    } | null>;
  } | null;
};

/**
 * __useGetAiProvidersQuery__
 *
 * To run a query within a React component, call `useGetAiProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiProvidersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAiProvidersQuery,
    GetAiProvidersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAiProvidersQuery, GetAiProvidersQueryVariables>(
    Operations.getAiProviders,
    options
  );
}
export function useGetAiProvidersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAiProvidersQuery,
    GetAiProvidersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAiProvidersQuery, GetAiProvidersQueryVariables>(
    Operations.getAiProviders,
    options
  );
}
export function useGetAiProvidersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAiProvidersQuery,
        GetAiProvidersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAiProvidersQuery,
    GetAiProvidersQueryVariables
  >(Operations.getAiProviders, options);
}
export type GetAiProvidersQueryHookResult = ReturnType<
  typeof useGetAiProvidersQuery
>;
export type GetAiProvidersLazyQueryHookResult = ReturnType<
  typeof useGetAiProvidersLazyQuery
>;
export type GetAiProvidersSuspenseQueryHookResult = ReturnType<
  typeof useGetAiProvidersSuspenseQuery
>;
export type GetAiProvidersQueryResult = Apollo.QueryResult<
  GetAiProvidersQuery,
  GetAiProvidersQueryVariables
>;
